<template>
  <span
    v-if="accessPointToLabelMap[level]"
    class="label label--access-point-badge"
    :class="{'label--subheading': limitWidth}">
    {{ accessPointToLabelMap[level] }}
  </span>
</template>

<script>
import { AccessPointsUtil } from '@/components/goals/common/access_points.js'

export default {
  name: 'AccessPointLabel',
  data() {
    return {
      accessPointToLabelMap: AccessPointsUtil.labelsMap
    }
  },
  props: {
    level: {
      type: String,
      required: true
    },
    limitWidth: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped lang="less">
.label.label--access-point-badge {
  background: #1c5498;
  color: #f8e81c;
  padding: 0.3em 0.7em 0.4em;
  &.label--subheading {
    padding: 0.2em 0.6em 0.3em;
  }
}
</style>
